import { API_ROOT } from '../apiConfig';
import axios from 'axios';

export const categoryResult = (filter) => {
	return axios.get(`${API_ROOT}/api/campaignCatgories?filter=${filter}`)
		.then(response => response)
}
